import React from "react";

const TitleHeader = ({ title, subtitle, newSignUp = false, isSignup = false }) => {
   return (
      <div>
         <div
            style={isSignup ? { paddingBottom: "10px" } : {}}
            className={newSignUp ? `ss-signin-title-text` : "title-new-app"}
         >
            {title}
         </div>
         {subtitle && <div className={newSignUp ? "ss-subtitle-text" : "subtitle-new-app"}>{subtitle}</div>}
      </div>
   );
};

export default TitleHeader;
